import { render } from "./mianThree.vue?vue&type=template&id=1e54bfe7&scoped=true"
import script from "./mianThree.vue?vue&type=script&lang=js"
export * from "./mianThree.vue?vue&type=script&lang=js"

import "./mianThree.vue?vue&type=style&index=0&id=1e54bfe7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e54bfe7"

export default script